import { Controller } from 'stimulus';
import {messages, overrideLinkTargets} from "../../public/common";

export default class extends Controller {
  static targets = ['entries', 'pagination', 'datetime',  'details'];

  loading = false;

  initialize() {
    if (this.hasDatetimeTarget) {
      this.formatDateTime();
    }

    if (this.hasDetailsTarget) {
      overrideLinkTargets({
        $containerEl: this.detailsTarget
      });
    }
  }

  formatDateTime() {
    const format = new Intl.DateTimeFormat('en-US', { dateStyle: 'short', yearStyle: 'full', timeStyle: 'short' });

    this.datetimeTargets.forEach(target => {
      const datetime = target.dataset.datetime;
      if (datetime) {
        target.innerText = format.format(new Date(datetime));
      }
    });
  }

  onScroll() {
    if (this.hasPaginationTarget) {
      const next = this.paginationTarget.querySelector('.pagination .page-item.next:not(.disabled) a');
      if (!this.loading && next) {
        const url = next.href

        const {body, documentElement} = document;
        const height = Math.max(body.scrollHeight, body.offsetHeight, documentElement.clientHeight, documentElement.scrollHeight, documentElement.offsetHeight);

        if (window.pageYOffset >= height - window.innerHeight - 100) {
          this.loadMore(url);
        }
      }
    }
  }

  loadMore(url) {
    const className = 'pagination_loading';
    const $pagination = this.paginationTarget.children[0];

    this.loading = true;
    $pagination.classList.add(className);

    Rails.ajax({
      type: 'GET',
      url,
      dataType: 'json',
      complete: () => {
        this.loading = false;
      },
      success: (data) => {
        const  { entries, pagination } = data;

        this.entriesTarget.insertAdjacentHTML('beforeend', entries);
        this.paginationTarget.innerHTML = pagination;
      },
      error: (e) => {
        $pagination.classList.remove(className);

        alert(messages ? messages.error_common : 'Something went wrong. Please try again');

        window.logError(e, {location: 'pagination loading'});
      }
    })
  }
}
